import { render } from "./IslerDetayView.vue?vue&type=template&id=4dae374b&scoped=true"
import script from "./IslerDetayView.vue?vue&type=script&lang=js"
export * from "./IslerDetayView.vue?vue&type=script&lang=js"

import "./IslerDetayView.vue?vue&type=style&index=0&id=4dae374b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dae374b"]])

export default __exports__